import BudgetPerRecipient from "@/components/campaignBuilder/BudgetPerRecipient";
import GfgStaffOnly from "@/components/campaignBuilder/GfgStaffOnly";
import WalletSelect from "@/components/campaignBuilder/WalletSelect";
import { FUNDING_WALLET_TEXT } from "@/constants/campaignBuilder";
import { useCampaignBuilder } from "@/context/CampaignBuilderContext";
import { isBudgetLocked } from "@/utils/campaign-gating-helper";

export default function CollectionStep() {
  const {
    canChooseWallet,
    fundingWallets,
    fundingWalletsLoading,
    fundingGroupId,
    chooseFundingWallet,
    campaignStatus,
  } = useCampaignBuilder();

  return (
    <div className="max-w-225 mx-auto px-5 py-8 w-full">
      <h1 className="mb-1">Choose a collection.</h1>
      <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <p className="text-graphite">Recipients pick one gift from your collection.</p>
        {canChooseWallet && (
          <div className="w-full sm:w-80 sm:shrink-0">
            <WalletSelect
              label={FUNDING_WALLET_TEXT.fundingLabel}
              wallets={fundingWallets}
              value={fundingGroupId}
              onChange={(id) => void chooseFundingWallet(id)}
              disabled={fundingWalletsLoading || isBudgetLocked(campaignStatus)}
              surface="background"
            />
          </div>
        )}
      </div>
      <BudgetPerRecipient />
      <GfgStaffOnly />
    </div>
  );
}
